<div class="waiting-room-reason-dialog">
  <h2 mat-dialog-title class="dialog-title">
    <mat-icon class="title-icon">info</mat-icon>
    {{ data.title || 'Reason for Moving Back to Waiting Room' }}
  </h2>

  <mat-dialog-content class="dialog-content">
    @if (data.message) {
    <p class="info-message">{{ data.message }}</p>
    } @if (!data.message) {
    <p class="info-message">
      Please select a reason for moving this order back to the waiting room:
    </p>
    }

    <mat-form-field appearance="outline" class="full-width mm-mt-2">
      <mat-label>Select Reason</mat-label>
      <mat-select
        [(value)]="selectedReason"
        (selectionChange)="onReasonSelection($event.value)"
      >
        @for (reason of reasons; track reason) {
        <mat-option [value]="reason">
          {{ reason }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (showOtherTextArea) {
    <mat-form-field appearance="outline" class="full-width mm-mt-2">
      <mat-label>Please specify</mat-label>
      <textarea
        matInput
        [(ngModel)]="otherReasonText"
        rows="3"
        placeholder="Enter the reason..."
        [required]="showOtherTextArea"
      >
      </textarea>
    </mat-form-field>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="onCancel()" class="mm-mr-2">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!canSubmit()">
      Confirm
    </button>
  </mat-dialog-actions>
</div>
